module.exports = __webpack_public_path__ + "img/Vip_banner.b6fc0fcf.png";